import { render, staticRenderFns } from "./DevelopmentHistory.vue?vue&type=template&id=ecc22fd0&"
import script from "./DevelopmentHistory.vue?vue&type=script&lang=js&"
export * from "./DevelopmentHistory.vue?vue&type=script&lang=js&"
import style0 from "./DevelopmentHistory.vue?vue&type=style&index=0&id=ecc22fd0&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports